import request from '@/utils/request'

// 车辆-新增
export const addBicycles = (pageData, formData) => {
    return request.post(`/bicycles`, formData);
};

// 车辆列表
export const listBicycles = (pageData, formData) => {
    return request.get(`/bicycles/${pageData.page}/${pageData.pageSize}`, {params: formData})
}

// 车辆详情
export const detailBicycles = (id) => {
    return request.get(`/bicycles/${id}`)
}

// 车辆-修改
export const editBicycles = (updateData) => {
    return request.put('/bicycles', updateData)
}

// 车辆列表导出
export const exportBicycles = (formData) => {
    return request.get(`/bicycles/export`, {params: formData, responseType: "blob"})
}

// 车辆导入
export const importBicycles = (formData) => {
    return request.post(`/bicycles/import`, formData);
};
